import React from "react";
import { useIntl } from "react-intl";

export default function NationalChampionships() {
  const intl = useIntl();

  return (
    <>
      <div>{intl.formatMessage({ id: "navbar.nationalChampionships" })}</div>
    </>
  );
}
